import style from './ImportantFieldIndicator.module.scss';

import { FixedIcon } from '../Icon';

export interface ExampleProps {}

interface Props extends ExampleProps {}

export function ImportantFieldIndicator(_: Props) {
    return <div className={style.root}>{FixedIcon.getAttentionIcon()}</div>;
}
